export type DisplayStatus = 'not_submitted' | 'pending' | 'approved' | 'needs_attention' | 'past_due' | 'in_review';

export const getStatusColor = (status: DisplayStatus): string => {
  const colors: Record<DisplayStatus, string> = {
    not_submitted: 'gray',
    pending: 'yellow',
    approved: 'green',
    needs_attention: 'red',
    past_due: 'red',
    in_review: 'yellow'
  };
  return colors[status];
};

export const getStatusLabel = (status: DisplayStatus): string => {
  const labels: Record<DisplayStatus, string> = {
    not_submitted: 'Not Submitted',
    pending: 'Pending Review',
    approved: 'Approved',
    needs_attention: 'Needs Attention',
    past_due: 'Past Due',
    in_review: 'In Review'
  };
  return labels[status];
}; 